<div class="container" [ngClass]="formControlClass">
    <ng-container *ngIf="isReadMode; else writeMode">
    <span [class.percent-read-value]="type === 'percent'">{{ displayValue }}{{ type === 'percent' && inputValue !== '' ? '%' : '' }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container" [ngClass]="formControlClass">
            <mat-form-field  [ngClass]="formControlClass" appearance="outline">
                <div [class.percent-input-container]="type === 'percent'">
                <input matInput [ngClass]="formControlClass"
                    [style.width]="type === 'percent' ? (displayValue.toString().length + 0.5) + 'ch' : null"
                    [type]="type === 'percent' ? 'text' : type"
                    [attr.inputmode]="type === 'percent' ? 'decimal' : (isInputNumberOrPercent ? 'numeric' : null)"
                    [attr.step]="isInputNumberOrPercent ? '1' : null"
                    [attr.min]="type === 'number' ? '0' : null"
                    [attr.max]="type === 'number' ? max : null"
                    [attr.maxlength]="maxLength"
                    [ngModel]="displayValue"
                    (focus)="onFocus()"
                    (keydown)="onNumberKeyDown($event)"
                    (input)="onNumberInput($event)"
                    (ngModelChange)="onValueChange($event)" (blur)="onBlur()"
                    [disabled]="effectiveDisabled"/>
                <span *ngIf="type === 'percent' && inputValue !== ''" aria-hidden="true">%</span>
                </div>
            </mat-form-field>
        </div>
    </ng-template>
</div>